export const UPDATE_BUSINESS_START_YEAR = 'UPDATE_BUSINESS_START_YEAR';
export const UPDATE_BUSINESS_REVENUE = 'UPDATE_BUSINESS_REVENUE';
export const SET_MODAL_COMPLETE_BUSINESS_PROFILE =
  'SET_MODAL_COMPLETE_BUSINESS_PROFILE';
